import { useState, useEffect } from 'react';
import Section from '../components/Section';
import Card from '../components/Card';
import MoleculeDecor from '../components/MoleculeDecor';
import { useAuth } from '../context/AuthContext';
import { getProfile } from '../api/profile';
import { TEAM_MEMBERS } from '../constants/team';
import styles from './Team.module.css';

const Team = () => {
  const { token } = useAuth();
  const [isPaid, setIsPaid] = useState(false);

  useEffect(() => {
    if (!token) {
      setIsPaid(false);
      return;
    }
    getProfile(token)
      .then((profile) => {
        const payUntil = profile.pay_until ? new Date(profile.pay_until) : null;
        setIsPaid(payUntil !== null && payUntil > new Date());
      })
      .catch(() => setIsPaid(false));
  }, [token]);

  return (
  <>
    {/* Hero-шапка */}
    <section className={styles.pageHero}>
      <MoleculeDecor style={{ right: '5%', bottom: '-20px', width: 180, height: 180, opacity: 0.45 }} />
      <div className="container">
        <p className={styles.pageHeroLabel}>Люди проекта</p>
        <h1 className={styles.pageHeroTitle}>Спикеры</h1>
        <p className={styles.pageHeroSubtitle}>
          Врачи и специалисты, объединённые одной целью — помочь вам управлять своим
          здоровьем на основе данных и современной науки.
        </p>
      </div>
    </section>

    {/* Основатель */}
    <Section bg="white">
      {TEAM_MEMBERS.filter((m) => m.isFounder).map((member) => (
        <div key={member.id} className={styles.founderCard}>
          <div className={styles.founderPhoto}>
            <img
              src="/images/roman-terushkin.jpg"
              alt="Роман Терушкин — врач-эндокринолог, основатель проекта"
              className={styles.founderPhotoImg}
            />
          </div>
          {/* Информация */}
          <div className={styles.founderInfo}>
            <span className={styles.founderBadge}>Основатель</span>
            <h2 className={styles.founderName}>{member.name}</h2>
            <p className={styles.founderRole}>{member.role}</p>
            <p className={styles.founderDesc}>{member.description}</p>
            <p className={styles.founderDesc}>
              Терушкин ОС — это моё главное детище. Здесь собраны лучшие специалисты,
              объединённые общей идеей: здоровье — это управляемая система, и мы можем
              помочь вам взять её под контроль.
            </p>
          </div>
        </div>
      ))}
    </Section>

    {/* Остальные участники команды */}
    <Section
      bg="gray"
      title="Спикеры клуба"
      subtitle="Каждый участник нашей команды — признанный эксперт в своей области"
    >
      <div className={styles.teamGrid}>
        {/* Роман Терушкин — первый спикер, разблюрен */}
        <div className={styles.memberCardWrap}>
          <Card variant="team">
            <div className={styles.memberPhoto}>
              <img
                src="/images/roman-terushkin-speaker.jpg"
                alt="Роман Терушкин"
                className={styles.memberPhotoImg}
              />
            </div>
            <h3 className={styles.memberName}>Роман Терушкин</h3>
            <p className={styles.memberRole}>Основатель, врач-эндокринолог</p>
            <p className={styles.memberDesc}>
              Специалист в области превентивной и функциональной медицины с 10-летним опытом. Создал методику управления здоровьем на основе данных и актуальных научных исследований.
            </p>
          </Card>
        </div>
        {/* Остальные спикеры — заблюрены */}
        {TEAM_MEMBERS.filter((m) => !m.isFounder).map((member) => (
          <div key={member.id} className={styles.memberCardWrap}>
            <Card variant="team" className={styles.memberCardBlurred}>
              <div className={styles.memberPhoto}>
                <svg viewBox="0 0 80 80" fill="none">
                  <circle cx="40" cy="28" r="18" fill="rgba(42,157,143,0.2)" />
                  <ellipse cx="40" cy="72" rx="28" ry="16" fill="rgba(42,157,143,0.12)" />
                </svg>
              </div>
              <h3 className={styles.memberName}>{member.name}</h3>
              <p className={styles.memberRole}>{member.role}</p>
              <p className={styles.memberDesc}>{member.description}</p>
            </Card>
            <div className={styles.memberCardBadge}>Скоро</div>
          </div>
        ))}
      </div>
    </Section>

    {/* Призыв — только для неоплативших */}
    {!isPaid && (
      <Section
        bg="white"
        title="Хотите работать с нашей командой?"
        subtitle="Вступите в клуб и получите доступ к персональным консультациям с нашими специалистами"
      >
        <div className={styles.cta}>
          <a href="/club" className={styles.ctaButton}>
            Узнать об условиях вступления
          </a>
        </div>
      </Section>
    )}
  </>
  );
};

export default Team;
